// TODO:: Update error message mapping to remove eslint complexity issue
import i18n from 'i18next';

import { EMainProductCodeType } from '../api/config';
import { companyService } from '../services/company';
import { ECommonResponseCode } from './types';

export const responseCodeToMessage: Record<ECommonResponseCode, () => string> = {
  [ECommonResponseCode.R_1000]: () => 'Duplicate tenant ID',
  [ECommonResponseCode.R_1001]: () => 'Invalid company ID',
  [ECommonResponseCode.B_1000]: () => 'General error',
  [ECommonResponseCode.B_1001]: () => 'Invalid credentials, please try again',
  [ECommonResponseCode.B_1002]: () => 'Invalid user status',
  [ECommonResponseCode.B_1003]: () => 'Role used by user',
  [ECommonResponseCode.B_1004]: () => 'Verification code expired',
  [ECommonResponseCode.B_1005]: () => 'Verification code invalid',
  [ECommonResponseCode.B_1006]: () => 'Failed to export CSV',
  [ECommonResponseCode.B_1007]: () => `Admin role's privilege cannot be edited`,
  [ECommonResponseCode.B_1008]: () => 'Symbol config refresh failed',
  [ECommonResponseCode.C_MT_0001]: () => i18n.t('Please contact your account manager for more information'),
  [ECommonResponseCode.MT4_0000]: () => i18n.t('Trading server error. Please try again later.'),
  [ECommonResponseCode.MT4_1000]: () => i18n.t('General trading error. Please try again later.'),
  [ECommonResponseCode.MT4_1001]: () => i18n.t('Invalid order'),
  [ECommonResponseCode.MT4_1002]: () => i18n.t('Invalid Trading Account ID'),
  [ECommonResponseCode.MT4_1003]: () => i18n.t('Invalid order volume'),
  [ECommonResponseCode.MT4_1004]: () => i18n.t('Insufficient balance'),
  [ECommonResponseCode.MT4_1005]: () => i18n.t('Invalid Stop loss or Take profit'),
  [ECommonResponseCode.MT4_1006]: () => i18n.t('Invalid credentials, please try again.'),
  [ECommonResponseCode.MT4_1007]: () => i18n.t('No changes made.'),
  [ECommonResponseCode.MT4_1008]: () => i18n.t('Trading for selected symbol is off quotes'),
  [ECommonResponseCode.MT4_1009]: () => i18n.t('Invalid Price submitted.'),
  [ECommonResponseCode.MT4_1010]: () => i18n.t('Invalid current password'),
  [ECommonResponseCode.MT4_1011]: () => i18n.t('Invalid password combination. Please try again.'),
  [ECommonResponseCode.MT4_1012]: () => i18n.t('Invalid user group. Please contact customer support.'),
  [ECommonResponseCode.MT4_1013]: () =>
    i18n.t('Trading is not allowed for this account. Please contact customer support.'),
  [ECommonResponseCode.MT4_1014]: () => i18n.t('Account is disabled. Please contact customer support.'),
  [ECommonResponseCode.MT4_1015]: () => i18n.t('Failed to submit order'),
  [ECommonResponseCode.MT4_1016]: () => i18n.t('No order has been deleted.'),
  [ECommonResponseCode.MT4_1017]: () => i18n.t('No order has been closed.'),
  [ECommonResponseCode.S2T_0000]: () => i18n.t('Server error. Please try again later.'),
  [ECommonResponseCode.S2T_1000]: () => i18n.t('General error. Please try again later.'),
  [ECommonResponseCode.S2T_1001]: () => i18n.t('Invalid credentials, please try again.'),
  [ECommonResponseCode.S2T_1002]: () => i18n.t('New password and confirm password are not the same'),
  [ECommonResponseCode.S2T_1003]: () => i18n.t('Invalid current password'),
  [ECommonResponseCode.S2T_1004]: () =>
    i18n.t('Password must be 6-20 characters long, with at least 1 uppercase letter and 1 number'),
  [ECommonResponseCode.S2T_1005]: () => i18n.t('Mobile number has been registered'),
  [ECommonResponseCode.S2T_1006]: () => i18n.t('Email has been registered'),
  [ECommonResponseCode.S2T_1007]: () => i18n.t('Username has been registered'),
  [ECommonResponseCode.S2T_1008]: () => i18n.t('Please enter a password that has not been used before.'),
  [ECommonResponseCode.S2T_1009]: () => i18n.t('Email is not verified. Please verify and try again.'),
  [ECommonResponseCode.S2T_1010]: () => i18n.t('New password must be at least 6 characters long'),
  [ECommonResponseCode.S2T_1011]: () => i18n.t('Old password must be at least 6 characters long'),
  [ECommonResponseCode.S2T_1012]: () => i18n.t('Single Sign On Failed. Please try again.'),
  [ECommonResponseCode.S2T_1013]: () => i18n.t('Invalid account type. Please contact customer support.'),
  [ECommonResponseCode.S2T_1014]: () => i18n.t('Password expired. Please login via CRM to update password.'),
  [ECommonResponseCode.S2T_1015]: () => i18n.t('Account locked. Please contact customer support.'),
  [ECommonResponseCode.A_1000]: () => i18n.t('Something went wrong. Please quit the application and try again.'),
  [ECommonResponseCode.A_1001]: () => i18n.t('Invalid symbol'),
  [ECommonResponseCode.A_1002]: () => i18n.t('No active trading account'),
  [ECommonResponseCode.A_1003]: () => i18n.t('Invalid demo account. Please contact customer support.'),
  [ECommonResponseCode.A_1004]: () => i18n.t('Invalid trading symbol'),
  [ECommonResponseCode.A_1005]: () => i18n.t('Invalid status, please try again later.'),
  [ECommonResponseCode.A_1006]: () => i18n.t('Invalid credentials, please try again.'),
  [ECommonResponseCode.A_1007]: () => i18n.t('Invalid Cross Account'),
  [ECommonResponseCode.A_1008]: () => i18n.t('Invalid Product Code'),
  [ECommonResponseCode.A_1009]: () => i18n.t('Invalid Lot Size'),
  [ECommonResponseCode.A_1010]: () => i18n.t('No trading is allowed for investor account'),
  [ECommonResponseCode.A_1013]: () => i18n.t('Account is locked'),
  [ECommonResponseCode.A_1014]: () => i18n.t('Invalid bulk close quantity'),
  [ECommonResponseCode.A_1015]: () => i18n.t('Password validation failed'),
  [ECommonResponseCode.A_1016]: () => i18n.t('Failed to read JSON string'),
  [ECommonResponseCode.A_1017]: () => i18n.t('Linked account expired'),
  [ECommonResponseCode.A_1018]: () => i18n.t('Invalid remove account'),
  [ECommonResponseCode.A_1019]: () => i18n.t('Linked account password has changed'),
  [ECommonResponseCode.A_1020]: () => i18n.t('Account not linked'),
  [ECommonResponseCode.A_1021]: () => i18n.t('Account already linked'),
  [ECommonResponseCode.A_1022]: () => i18n.t('Demo account creation is disabled'),
  [ECommonResponseCode.A_1023]: () => i18n.t('New password cannot be the same as the previous 5 passwords.'),
  [ECommonResponseCode.A_1024]: () => i18n.t('Trader preference selected type is not valid for selected category'),
  [ECommonResponseCode.A_1025]: () => i18n.t('Trader preference input value is invalid'),
  [ECommonResponseCode.A_1026]: () => i18n.t('Invalid symbol for selected trader preference category'),
  [ECommonResponseCode.A_1027]: () => i18n.t('Invalid value for selected technical indicator'),
  [ECommonResponseCode.A_1028]: () => i18n.t('Fill policy is invalid'),
  [ECommonResponseCode.A_1029]: () => i18n.t('Trading of selected symbol is restricted due to market holiday'),
  [ECommonResponseCode.A_1030]: () => i18n.t('Symbol is disabled'),
  [ECommonResponseCode.A_1031]: () => i18n.t('One-Click Trading is currently disabled'),
  [ECommonResponseCode.A_1032]: () => i18n.t('Failed to export CSV'),
  [ECommonResponseCode.A_1033]: () => i18n.t('Invalid hidden column request'),
  [ECommonResponseCode.A_1034]: () => i18n.t('Invalid column preference'),
  [ECommonResponseCode.A_1035]: () => i18n.t('Dealer module disabled'),
  [ECommonResponseCode.A_1036]: () => i18n.t('Account unable to access dealer module'),
  [ECommonResponseCode.A_1037]: () => i18n.t('Invalid feature id'),
  [ECommonResponseCode.A_1038]: () => i18n.t('Invalid calendar event data range'),
  [ECommonResponseCode.A_1041]: () => i18n.t('Duplicated target price and condition'),
  [ECommonResponseCode.A_1042]: () => i18n.t('Duplicated target price and condition'),
  [ECommonResponseCode.A_1043]: () => i18n.t('Maximum number of alerts reached for this symbol.'),
  [ECommonResponseCode.A_1044]: () => i18n.t('Maximum total number of alerts reached.'),
  [ECommonResponseCode.A_1045]: () => i18n.t('Price Alert module is disabled.'),
  [ECommonResponseCode.A_1046]: () => i18n.t('Symbol is temporarily disabled.'),
  [ECommonResponseCode.A_2000]: () => i18n.t('Invalid configuration setting. Please contact customer support.'),
  [ECommonResponseCode.AQ_0000]: () => i18n.t('Server error. Please try again later'),
  [ECommonResponseCode.AQ_1000]: () => i18n.t('System General Error'),
  [ECommonResponseCode.AQ_1001]: () => i18n.t('System Invalid Login'),
  [ECommonResponseCode.OK]: () => '',
  [ECommonResponseCode.BAD_REQUEST]: () => '',
  [ECommonResponseCode.UNAUTHORIZED]: () => '',
  [ECommonResponseCode.FORBIDDEN]: () => '',
  [ECommonResponseCode.SERVER_ERROR]: () => i18n.t('Something went wrong. Please contact customer support.'),
  [ECommonResponseCode.MT5_0000]: () => i18n.t('Trading server error. Please try again later.'),
  [ECommonResponseCode.MT5_1000]: () => i18n.t('General trading error. Please try again later.'),
  [ECommonResponseCode.MT5_1001]: () => i18n.t('No order has been deleted.'),
  [ECommonResponseCode.MT5_1002]: () => i18n.t('No order has been closed.'),
  [ECommonResponseCode.MT5_10001]: () => i18n.t('General trading error. Please try again later.'),
  [ECommonResponseCode.MT5_10002]: () => i18n.t('General trading error. Please try again later.'),
  [ECommonResponseCode.MT5_10003]: () => i18n.t('General trading error. Please try again later.'),
  [ECommonResponseCode.MT5_10004]: () => i18n.t('The deviation must be smaller than the spread of the instrument.'),
  [ECommonResponseCode.MT5_10005]: () => i18n.t('Invalid price'),
  [ECommonResponseCode.MT5_10006]: () => i18n.t('Invalid order'),
  [ECommonResponseCode.MT5_10007]: () => i18n.t('Trader has canceled the request.'),
  [ECommonResponseCode.MT5_10008]: () => i18n.t('Order placed'),
  [ECommonResponseCode.MT5_10009]: () => i18n.t('Request completed'),
  [ECommonResponseCode.MT5_10010]: () => i18n.t('Your order has been filled partially.'),
  [ECommonResponseCode.MT5_10011]: () => i18n.t('An error occurred while processing the request.'),
  [ECommonResponseCode.MT5_10012]: () => i18n.t('Error: Request cancelled due to a timeout.'),
  [ECommonResponseCode.MT5_10013]: () => i18n.t('Invalid request'),
  [ECommonResponseCode.MT5_10014]: () => i18n.t('Invalid order volume'),
  [ECommonResponseCode.MT5_10015]: () => i18n.t('Invalid Price submitted.'),
  [ECommonResponseCode.MT5_10016]: () => i18n.t('Invalid Stop loss or Take profit'),
  [ECommonResponseCode.MT5_10017]: () => i18n.t('An error occurred while processing the request.'),
  [ECommonResponseCode.MT5_10018]: () => i18n.t('Market Closed'),
  [ECommonResponseCode.MT5_10019]: () => i18n.t('The request cannot be completed due to insufficient funds.'),
  [ECommonResponseCode.MT5_10020]: () => i18n.t('Price has changed. Please try again.'),
  [ECommonResponseCode.MT5_10021]: () => i18n.t('Error: No price quotes available to process the request.'),
  [ECommonResponseCode.MT5_10022]: () => i18n.t('Invalid Expiration Date. Please try again.'),
  [ECommonResponseCode.MT5_10023]: () => i18n.t("The order's status has been updated."),
  [ECommonResponseCode.MT5_10024]: () => i18n.t('Too many requests. Please try again.'),
  [ECommonResponseCode.MT5_10025]: () => i18n.t('No changes have been made to the trade request.'),
  [ECommonResponseCode.MT5_10026]: () => i18n.t('Autotrading is disabled by server.'),
  [ECommonResponseCode.MT5_10027]: () => i18n.t('Autotrading is disabled by client terminal.'),
  [ECommonResponseCode.MT5_10028]: () => i18n.t('Trade request is locked for processing.'),
  [ECommonResponseCode.MT5_10029]: () => i18n.t('Order or position is frozen'),
  [ECommonResponseCode.MT5_10030]: () => i18n.t('Invalid fill type'),
  [ECommonResponseCode.MT5_10031]: () => i18n.t('No connection exists with the trade server.'),
  [ECommonResponseCode.MT5_10032]: () => i18n.t('Operation is allowed for live accounts only.'),
  [ECommonResponseCode.MT5_10033]: () => i18n.t('Number of pending orders has reached the limit.'),
  [ECommonResponseCode.MT5_10034]: () => i18n.t('Volume of orders and positions for the symbol has reached the limit.'),
  [ECommonResponseCode.MT5_10035]: () => i18n.t('Incorrect or prohibited order type'),
  [ECommonResponseCode.MT5_10036]: () => i18n.t('Position has already been closed.'),
  [ECommonResponseCode.MT5_10037]: () => i18n.t('General trading error. Please try again later.'),
  [ECommonResponseCode.MT5_10038]: () => i18n.t('The closing volume requested exceeds the current position volume.'),
  [ECommonResponseCode.MT5_10039]: () => i18n.t('A close order already exists.'),
  [ECommonResponseCode.MT5_10040]: () => i18n.t('The number of open positions has reached the limit.'),
  [ECommonResponseCode.MT5_10041]: () =>
    i18n.t('The pending order activation request is rejected, or the order is canceled.'),
  [ECommonResponseCode.MT5_10042]: () => i18n.t('Only long positions are allowed.'),
  [ECommonResponseCode.MT5_10043]: () => i18n.t('Only short positions are allowed.'),
  [ECommonResponseCode.MT5_10044]: () => i18n.t('Only closing position is allowed.'),
  [ECommonResponseCode.MT5_10045]: () => i18n.t('Only First-In, First-Out rule is allowed for closing positions.'),
  [ECommonResponseCode.MT5_10046]: () => i18n.t('Trading opposing positions on a single symbol is not permitted.'),
  [ECommonResponseCode.MT5_10047]: () => i18n.t('Order has been deleted.'),
  [ECommonResponseCode.MT5_10048]: () =>
    i18n.t('Trading is not allowed for this account. Please contact customer support.'),
  [ECommonResponseCode.MT5_10049]: () =>
    i18n.t('Trading is not allowed for this account. Please contact customer support.'),
  [ECommonResponseCode.AX_1001]: () => i18n.t('Email address not found in our system.'),
  [ECommonResponseCode.AX_1002]: () =>
    i18n.t('An account already exists with this email address. Please log in with your existing account.'),
  [ECommonResponseCode.AX_1003]: () => i18n.t('Error creating demo account. Please try again later.'),
  [ECommonResponseCode.AX_1004]: () => i18n.t('Experience feature not supported'),
  [ECommonResponseCode.AX_1005]: () =>
    i18n.t('Your demo account is expired. Please kindly reach out to us at info@aquariux.com for assistance.'),
  [ECommonResponseCode.AX_1006]: () => i18n.t('Error resetting password. Please try again later.'),
  [ECommonResponseCode.AX_1008]: () =>
    i18n.t(
      'Your demo account has met the maximum time of extension, please refer to your latest reset password to login, or contact us at info@aquariux.com for assistance.'
    ),
  [ECommonResponseCode.AX_1009]: () =>
    i18n.t(
      'We couldn’t verify your account details. Please contact us at info@aquariux.com or reset your password below using your registered email address.'
    ),
  [ECommonResponseCode.AX_1010]: () => '', // Not meant to display any error message
  [ECommonResponseCode.AX_1011]: () =>
    i18n.t('Your account is expired, please contact info@aquariux.com for a live walk through.'),
  [ECommonResponseCode.CTRD_1010]: () => i18n.t('Email is being used by another account'),
  [ECommonResponseCode.CTRD_1011]: () => i18n.t('Invalid Request'),
  [ECommonResponseCode.SI_1006]: () => i18n.t('Email already in use.'),
  [ECommonResponseCode.SI_1007]: () => i18n.t('Email already in use.'),
  [ECommonResponseCode.SI_1016]: () => i18n.t('An OTP was recently sent to you. Please try again after 5 minutes.'),
  [ECommonResponseCode.SI_1017]: () => i18n.t('Invalid OTP'),
  [ECommonResponseCode.TW_0000]: () => i18n.t('Server Error'),
  [ECommonResponseCode.TW_1001]: () => i18n.t('General Error'),
  [ECommonResponseCode.TW_1002]: () => i18n.t('Failed to log in.'),
  [ECommonResponseCode.TW_1003]: () => i18n.t('Registration Error'),
  [ECommonResponseCode.TW_1004]: () => i18n.t('Invalid Send Code Type'),
  [ECommonResponseCode.TW_1005]: () => i18n.t('Incorrect verification code'),
  [ECommonResponseCode.TW_1006]: () => i18n.t('Session Timeout'),
  [ECommonResponseCode.TW_1007]: () => i18n.t('Account Locked'),
  [ECommonResponseCode.TW_1008]: () => i18n.t('Unauthorised'),
  [ECommonResponseCode.TW_1009]: () => i18n.t('Invalid Phone Number'),
  [ECommonResponseCode.TW_1010]: () => i18n.t('An OTP was recently sent to you. Please try again after 1 minute.'),
  [ECommonResponseCode.SI_1001]: () => i18n.t('Invalid Verification Code'),
  [ECommonResponseCode.SI_1003]: () => '', // Error handled in the form
  [ECommonResponseCode.HRZ_1013]: () => '', // Error handled in the form
  [ECommonResponseCode.CRM_1001]: () => i18n.t('Invalid credentials, please try again.'),
  [ECommonResponseCode.PW_1001]: () => i18n.t('Copy trading validation error'),
  [ECommonResponseCode.PW_1002]: () => i18n.t('Copy trading internal error'),
  [ECommonResponseCode.PW_1003]: () => i18n.t('Copy trading missing authentication'),
  [ECommonResponseCode.PW_1004]: () => i18n.t('Copy trading missing permission'),
  [ECommonResponseCode.PW_1005]: () => i18n.t('Copy trading not link that copier before.'),
  [ECommonResponseCode.PW_1006]: () => i18n.t('Copy trading not follow that strategy before.'),
  [ECommonResponseCode.PW_1007]: () => i18n.t('Copy trading already follow that strategy before'),
  [ECommonResponseCode.PW_1008]: () => i18n.t('Copy trading not exist signal'),
  [ECommonResponseCode.PW_1009]: () => i18n.t('Copy trading feature is not enabled'),
  [ECommonResponseCode.PW_1010]: () => i18n.t('Copy trading invalid broker code'),
  [ECommonResponseCode.PW_1011]: () => i18n.t('Copy trading cannot find the copier'),
  [ECommonResponseCode.PW_1012]: () => i18n.t('Copy trading already link this copier before'),
  [ECommonResponseCode.PW_1013]: () => i18n.t('Copy trading soft stop level must be less than hard stop level'),
  [ECommonResponseCode.PW_1014]: () => i18n.t('Copy trading hard stop level must be greater than current level'),
  [ECommonResponseCode.PW_1015]: () => i18n.t('Copy trading soft stop level must be greater than current level'),
  [ECommonResponseCode.PW_1016]: () => i18n.t('BUY: StopPrice must be lower than current price'),
  [ECommonResponseCode.PW_1017]: () => i18n.t('BUY: LimitPrice must be higher than current price'),
  [ECommonResponseCode.PW_1018]: () => i18n.t('BUY: StopPrice must be lower than LimitPrice'),
  [ECommonResponseCode.PW_1019]: () => i18n.t('SELL: StopPrice must be higher than current price'),
  [ECommonResponseCode.PW_1020]: () => i18n.t('SELL: LimitPrice must be lower than current price'),
  [ECommonResponseCode.PW_1021]: () => i18n.t('SELL: StopPrice must be higher than LimitPrice'),
  [ECommonResponseCode.PW_1022]: () => i18n.t('Trade size value must be greater than or equal to the min trade size'),
  [ECommonResponseCode.PW_1023]: () =>
    i18n.t('Copy Trade Provider has received too many requests, please wait and retry'),
  [ECommonResponseCode.PW_1024]: () =>
    i18n.t('This account is not activated for copy trading. Please contact your broker'),
  [ECommonResponseCode.PW_1025]: () => i18n.t('Combination of Server and Broker is not valid. Please retry again'),
  [ECommonResponseCode.PW_1026]: () => i18n.t('Account has already been linked. Please retry again'),
  [ECommonResponseCode.PW_1027]: () => i18n.t('Account is unknown to Broker. Please retry again'),
  [ECommonResponseCode.PW_1028]: () => i18n.t('Account credentials are invalid. Please try again'),
  [ECommonResponseCode.PW_1029]: () => i18n.t('Copy trading invalid provider oauth client id')
};

/**
 * New message overrides for the above ones
 */
export const newResponseCodeToMessage: Partial<Record<ECommonResponseCode, () => string>> = {
  [ECommonResponseCode.MT5_10019]: () => i18n.t('Insufficient balance')
};

/**
 * Error message that should be treated as generic errors and not displayed to the user
 */
export const genericErrorMessage = ['system error'];

/**
 * Known network error messages from the request layer that should be translated
 */
export const NETWORK_ERROR_MESSAGE = 'Network error. Please try again later.';

export const mapResponseCodeToMessage = (code: ECommonResponseCode, fallback = 'Unexpected error') => {
  // Translate known network error messages
  if (fallback === NETWORK_ERROR_MESSAGE) {
    return i18n.t('Network error. Please try again later.');
  }

  const companyIntegration = companyService.getCompanyIntegration();

  // For non-Horizon companies, check for custom messages first
  if (companyIntegration !== EMainProductCodeType.HORIZON && newResponseCodeToMessage[code]) {
    return newResponseCodeToMessage[code]?.() || fallback;
  }

  // Fall back to original mapping
  return responseCodeToMessage[code]?.() || fallback;
};
